// USA
export const locale = {
  GENERAL: {
    APP_TITLE: "Lyunik LTD"
  },
  TRANSLATOR: {
    SELECT: "Select your language"
  },
  DRIVER_ACCESS: {
    LOGIN_TITLE: "Driver login",
    LOGIN_HELP: "Enter the machine registration plate and driver password.",
    REGISTRATION_PLATE: "Registration plate",
    PASSWORD: "Password",
    LOGIN_BUTTON: "Login",
    REQUIRED_LOGIN_FIELDS: "Please enter a registration plate and password.",
    LOGIN_ERROR: "An error occurred during login.",
    INVALID_LOGIN: "Invalid registration plate or password.",
    LOGIN_SUCCESS: "Login successful.",
    MACHINE_TITLE: "Machine",
    LOADING: "Loading...",
    MACHINE_TYPE: "Type",
    SERVICE_TYPE: "Service type",
    SIGNAL: "Signal",
    LOGOUT: "Logout",
    SIGNAL_SUCCESS: "The signal was sent successfully.",
    DATE_TIME: "Date and time",
    DESCRIPTION: "Problem description",
    DESCRIPTION_PLACEHOLDER: "Describe the machine problem",
    SEND_SIGNAL: "Send signal",
    DESCRIPTION_REQUIRED: "Please describe the problem with at least 3 characters.",
    DATE_TIME_REQUIRED: "Please select a date and time.",
    SIGNAL_ERROR: "An error occurred while sending.",
    CURRENT_WORK: "Current work",
    DETAILS: "Details",
    SERVICE_HISTORY: "Service history",
    SIGNALS_AND_TASKS: "Signals and tasks",
    REPORT_SIGNAL: "Report signal",
    SERVICE_VISIT: "Service visit",
    ON_ROAD: "On road",
    NO_TASKS: "No tasks in this service visit.",
    NO_CURRENT_WORK: "No current service work.",
    AWAITING_ASSIGNMENT: "Reported signals awaiting assignment",
    SERVICE_RECORD: "Service record",
    KILOMETERS: "km",
    MOTO_HOURS: "moto hours",
    NO_SERVICE_HISTORY: "No service history.",
    NO_WORK_HISTORY: "No signal or task history.",
    PREVIOUS: "Previous",
    NEXT: "Next",
    PAGE: "Page {page}",
    DASHBOARD_ERROR: "Unable to load service information. Please try again."
  },
  MECHANIC_HOURS: {
    SAVED_SUCCESS: "Mechanic hours were saved successfully.",
    DELETED_SUCCESS: "Mechanic hours were deleted successfully."
  },
  SERVICE_VISIT_COMMENTS: {
    TITLE: "Service visit comments",
    ADD: "Add comment",
    EDIT: "Edit comment",
    SERVICE_VISIT: "Service visit",
    AUTHOR: "Author",
    BODY: "Comment",
    CREATED_AT: "Created at",
    SAVE_FAILED: "Could not save the comment.",
    DELETE_FAILED: "Could not delete the comment."
  },
  FORM_LABELS: {
    LOCATION: "Location",
    HOURS: "Hours",
    IS_ON_ROAD: "On road",
    ON_ROAD_NOTE: "On-road note",
    SERVICE_LOCATION: "Service location",
    SERVICE_LOCATION_TYPE: "Service location type",
    SERVICE_TYPES: "Service types",
    SERVICE_TYPE: "Service type",
    MACHINE: "Machine",
    DATE_FROM: "Date from",
    DATE_TO: "Date to",
    DURATION: "Duration",
    DESCRIPTION: "Description",
    TYPE: "Type",
    PRIORITY: "Priority",
    STATUS: "Status",
    NOTE: "Note"
  },
  SERVICE_VISITS: {
    BOARD: "Board",
    CALENDAR: "Calendar",
    ITEMS: "Items",
    CUSTOM_TASK: "Custom task",
    CUSTOM_TASKS: "Custom tasks",
    TASKS: "Tasks",
    HOURS_SHORT: "h",
    NO_VISITS_IN_STATUS: "No service visits",
    NO_VISITS_IN_MONTH: "No service visits in the selected month",
    LIST_LOAD_ERROR: "Service visits could not be loaded. Please try again.",
    NO_CUSTOM_TASKS: "No custom tasks",
    SELECT_MACHINE_FIRST: "Select a machine first.",
    NO_SIGNALS: "No current machine service signals.",
    NO_SERVICE_TYPES: "No service types connected to this machine.",
    LAST_SERVICE: "Last service",
    NO_LAST_SERVICE: "No previous service",
    COMPLETION_MILEAGE_TITLE: "Complete service visit",
    COMPLETION_DETAILS_TITLE: "Complete service visit",
    COMPLETION_KILOMETERS: "Kilometers",
    COMPLETION_MOTO_HOURS: "Moto hours",
    MOTO_HOURS_SHORT: "h",
    COMPLETION_MILEAGE_REQUIRED: "Enter the current kilometers or moto hours to finish this visit.",
    TASKS_MUST_BE_TERMINAL: "All tasks must be finished or denied before the visit can be finished.",
    HOURS_WORKED: "Hours worked",
    WORK_DONE: "Work done",
    TASK_STATUS_UPDATED: "Task status has been updated.",
    TASK_UPDATED: "Task has been updated.",
    TASK_CREATED: "Task has been created.",
    TASKS_REORDERED: "Tasks have been reordered.",
    VISIT_REORDERED: "Visit order has been updated.",
    VISIT_REORDER_FAILED: "Visit order could not be updated.",
    TASK_DETAILS: "Task details",
    ADD_TASK: "Add task",
    TASK_NAME: "Task name",
    TASK_UPDATE_FAILED: "Please fill all required fields correctly.",
    HISTORY: {
      TITLE: "History",
      ADD_COMMENT: "Add comment",
      EDIT_COMMENT: "Edit comment",
      COMMENT: "Comment",
      COMMENT_REMOVED: "Comment removed",
      COMMENT_SAVE_FAILED: "Could not save the comment.",
      COMMENT_DELETE_FAILED: "Could not delete the comment.",
      EDITED: "edited",
      CREATED: "Service visit created",
      UPDATED: "Service visit updated",
      DELETED: "Service visit deleted",
      SYSTEM: "System",
      MECHANIC_ADDED: "Mechanic added: {name}",
      MECHANIC_REMOVED: "Mechanic removed: {name}",
      TASK_ADDED: "Task added: {name}",
      TASK_REMOVED: "Task removed: {name}",
      TASK_UPDATED: "Task updated: {name} — {changes}",
      FIELD_CHANGED: "{field}: {before} → {after}",
      SNAPSHOT_MACHINE: "Machine: {name}",
      SNAPSHOT_STATUS: "Status: {name}",
      SNAPSHOT_PRIORITY: "Priority: {name}",
      SNAPSHOT_PERIOD: "Period: {from} – {to}",
      SNAPSHOT_MECHANICS: "Mechanics: {names}",
      FIELDS: {
        MACHINE: "Machine",
        STATUS: "Status",
        PRIORITY: "Priority",
        IS_ON_ROAD: "On road",
        ON_ROAD_NOTE: "On-road note",
        SERVICE_LOCATION: "Location",
        DATE_FROM: "Start date",
        DATE_TO: "End date",
        DURATION: "Duration",
        SERVICE_MILEAGE: "Kilometers/moto hours",
        HOURS_WORKED: "Hours worked",
        WORK_DONE: "Work done",
        NAME: "Description",
        NOTE: "Note"
      }
    }
  },
  SERVICE_MACHINE_ROWS: {
    PAST_ROWS: "Past service records",
    LOCKED_BY_SERVICE_VISIT:
      "This record was created from a service visit and cannot be edited or deleted.",
    VIEW_SERVICE_VISIT: "View service visit"
  },
  MACHINE_SERVICE_SIGNALS: {
    TITLE: "Machine service signals",
    LIST: "List",
    SHOW: "View",
    DATE_TIME: "Date and time",
    MACHINE: "Machine",
    STAFF: "Staff",
    DESCRIPTION: "Description",
    LOADING: "Loading... Please wait",
    NOT_FOUND: "The record was not found."
  },
  MENU: {
    SECTION: {
      SETTINGS: "Settings"
    },
    ITEM: {
      LIST: "List",
      ADD: "Add",
      EDIT: "Edit",
      ACTIONS: "Actions",
      DASHBOARD: "Home",
      PRODUCTS: "Products",
      INGREDIENTS: "Ingredients",
      RECIPES: "Recipes",
      PRICES: "Prices",
      STOCK: "Stock",
      USERS: "Users",
      ROLES: "Roles",
      SERVICE: {
        MACHINE_SERVICE_SIGNALS: "Machine service signals",
        LOCATIONS: "Service locations",
        VISITS: "Service visits",
        VISITS_BOARD: "Service visits board",
        VISITS_CALENDAR: "Service visits calendar",
        VISIT_COMMENTS: "Service visit comments",
        MECHANICS: "Mechanics",
        MECHANIC_HOURS: "Mechanic hours"
      },
      ASSETS: {
        LIST: "List"
      }
    }
  },
  BUTTON: {
    NEW: "New",
    SEND: "Send",
    READY: "Done",
    FULLSCREEN: "Fullscreen",
    BACK: "Back",
    CANCEL: "Cancel",
    PLEASE_CONFIRM: "Please confirm",
    SAVE: "Save",
    SAVE_AND_CONTINUE: "Save and continue",
    SAVE_AND_ADD_NEW: "Save and add new",
    SAVE_AND_EXIT: "Save and exit",
    CLOSE: "Close",
    APPLY: "Apply"
  },
  LABELS: {
    ADD_NEW: "Add new",
    FILTERS: "Filters",
    DETAILS: "Details",
    CLEAR: "Clear",
    SEARCH: "Search",
    EDIT: "Edit",
    LIST: "List",
    NO_DATA: "No data",
    NO_PERMISSIONS: "No permissions",
    VIEW: "View",
    YES: "Yes",
    NO: "No",
    KM: "km",
    NA: "N/A"
  },
  ALERTS: {
    SUCCESS: "Success",
    ERROR: "Error",
    WARNING: "Warning"
  },
  AUTH: {
    GENERAL: {
      WELCOME: "Welcome to Lyunik LTD!",
      WELCOME_DESCRIPTION:
        "Virtual Inventory Management System ",
      FOOTER_LEFT: "Lyunik",
      OR: "Or",
      SUBMIT_BUTTON: "Submit",
      NO_ACCOUNT: "Don't have an account?",
      SIGNUP_BUTTON: "Sign Up",
      FORGOT_BUTTON: "Forgot Password",
      BACK_BUTTON: "Back",
      PRIVACY: "",
      LEGAL: "",
      CONTACT: ""
    },
    LOGIN: {
      TITLE: "Login Account",
      DESCRIPTION:
        "Please contact the website Administrator to obtain username and password.",
      VALID_EMAIL: "A valid email address is required.",
      VALID_PASSWORD: "Password is required.",
      BUTTON: "Sign In"
    },
    FORGOT: {
      TITLE: "Forgot Password?",
      DESC: "Enter your email to reset your password",
      SUCCESS: "Your account has been successfully reset."
    },
    REGISTER: {
      TITLE: "Sign Up",
      DESC: "Enter your details to create your account",
      SUCCESS: "Your account has been successfuly registered."
    },
    INPUT: {
      EMAIL: "Email",
      FULLNAME: "Fullname",
      PASSWORD: "Password",
      CONFIRM_PASSWORD: "Confirm Password",
      USERNAME: "Username"
    },
    VALIDATION: {
      INVALID: "{{name}} is not valid",
      REQUIRED: "{{name}} is required",
      MIN_LENGTH: "{{name}} minimum length is {{min}}",
      AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
      NOT_FOUND: "The requested {{name}} is not found",
      INVALID_LOGIN: "The login detail is incorrect",
      REQUIRED_FIELD: "Required field",
      MIN_LENGTH_FIELD: "Minimum field length:",
      MAX_LENGTH_FIELD: "Maximum field length:",
      INVALID_FIELD: "Field is not valid"
    }
  },
  ECOMMERCE: {
    COMMON: {
      SELECTED_RECORDS_COUNT: "Selected records count: ",
      ALL: "All",
      SUSPENDED: "Suspended",
      ACTIVE: "Active",
      FILTER: "Filter",
      BY_STATUS: "by Status",
      BY_TYPE: "by Type",
      BUSINESS: "Business",
      INDIVIDUAL: "Individual",
      SEARCH: "Search",
      IN_ALL_FIELDS: "in all fields"
    },
    ECOMMERCE: "eCommerce",
    CUSTOMERS: {
      CUSTOMERS: "Customers",
      CUSTOMERS_LIST: "Customers list",
      NEW_CUSTOMER: "New Customer",
      DELETE_CUSTOMER_SIMPLE: {
        TITLE: "Customer Delete",
        DESCRIPTION: "Are you sure to permanently delete this customer?",
        WAIT_DESCRIPTION: "Customer is deleting...",
        MESSAGE: "Customer has been deleted"
      },
      DELETE_CUSTOMER_MULTY: {
        TITLE: "Customers Delete",
        DESCRIPTION: "Are you sure to permanently delete selected customers?",
        WAIT_DESCRIPTION: "Customers are deleting...",
        MESSAGE: "Selected customers have been deleted"
      },
      UPDATE_STATUS: {
        TITLE: "Status has been updated for selected customers",
        MESSAGE: "Selected customers status have successfully been updated"
      },
      EDIT: {
        UPDATE_MESSAGE: "Customer has been updated",
        ADD_MESSAGE: "Customer has been created"
      }
    }
  },
  PROFILE: {
    TITLE: "User Profile",
    HI: "Hi",
    LOGOUT: "Logout",
    MY_PROFILE: "My account",
    PROFILE_SETTINGS: "Account settings"
  },
  USER:{
    FORM:{
      VALID_EMAIL: "A valid email address is required.",
      VALID_NAME: "A valid name is required..",
    }
  },
  PERMISSIONS: {
    "assignors-groups-show": "Assignor groups - list",
    "assignors-groups-create": "Assignor groups - create",
    "assignors-groups-update": "Assignor groups - update",
    "assignors-groups-delete": "Assignor groups - delete",
    "assignors-show": "Assignors - list",
    "assignors-create": "Assignors - create",
    "assignors-update": "Assignors - update",
    "assignors-delete": "Assignors - delete",
    "executors-show": "Executors - list",
    "executors-create": "Executors - create",
    "executors-update": "Executors - update",
    "executors-delete": "Executors - delete",
    "assignor-locations-show": "Assignor locations - list",
    "assignor-locations-create": "Assignor locations - create",
    "assignor-locations-update": "Assignor locations - update",
    "assignor-locations-delete": "Assignor locations - delete",
    "subcontractors-show": "Subcontractors - list",
    "subcontractors-create": "Subcontractors - create",
    "subcontractors-update": "Subcontractors - update",
    "subcontractors-delete": "Subcontractors - delete",
    "subcontractor-locations-show": "Subcontractor locations - list",
    "subcontractor-locations-create": "Subcontractor locations - create",
    "subcontractor-locations-update": "Subcontractor locations - update",
    "subcontractor-locations-delete": "Subcontractor locations - delete",
    "gas-stations-show": "Gas stations - list",
    "gas-stations-create": "Gas stations - create",
    "gas-stations-update": "Gas stations - update",
    "gas-stations-delete": "Gas stations - delete",
    "staff-show": "Staff - list",
    "staff-create": "Staff - create",
    "staff-update": "Staff - update",
    "staff-delete": "Staff - delete",
    "staff-vehicle-show": "Staff vehicles - list",
    "staff-vehicle-create": "Staff vehicles - create",
    "staff-vehicle-update": "Staff vehicles - update",
    "staff-vehicle-delete": "Staff vehicles - delete",
    "machines-types-show": "Machine types - list",
    "machines-types-create": "Machine types - create",
    "machines-types-update": "Machine types - update",
    "machines-types-delete": "Machine types - delete",
    "machines-show": "Owned machines - list",
    "machines-create": "Owned machines - create",
    "machines-update": "Owned machines - update",
    "machines-delete": "Owned machines - delete",
    "rented-machines-show": "Rented machines - list",
    "rented-machines-create": "Rented machines - create",
    "rented-machines-update": "Rented machines - update",
    "rented-machines-delete": "Rented machines - delete",
    "tank-charges-show": "Tank charges - list",
    "tank-charges-create": "Tank charges - create",
    "tank-charges-update": "Tank charges - update",
    "tank-charges-delete": "Tank charges - delete",
    "gps-tank-charges-show": "GPS tank charges - list",
    "gps-tank-charges-transfer": "GPS tank charges - transfer",
    "gps-tank-charges-delete": "GPS tank charges - delete",
    "bill-of-lading-show": "Bills of lading - list",
    "bill-of-lading-create": "Bills of lading - create",
    "bill-of-lading-update": "Bills of lading - update",
    "bill-of-lading-delete": "Bills of lading - delete",
    "protocols-show": "Protocols - list",
    "protocols-create": "Protocols - create",
    "protocols-update": "Protocols - update",
    "protocols-delete": "Protocols - delete",
    "protocols-finalize": "Protocols - finalize",
    "fuel-expenses-show": "Fuel expenses - list",
    "fuel-expenses-create": "Fuel expenses - create",
    "fuel-expenses-update": "Fuel expenses - update",
    "fuel-expenses-delete": "Fuel expenses - delete",
    "subcontractors-invoices-show": "Subcontractor expenses - list",
    "subcontractors-invoices-create": "Subcontractor expenses - create",
    "subcontractors-invoices-update": "Subcontractor expenses - update",
    "subcontractors-invoices-delete": "Subcontractor expenses - delete",
    "subcontractors-invoices-materials-show": "Material expenses - list",
    "subcontractors-invoices-materials-create": "Material expenses - create",
    "subcontractors-invoices-materials-update": "Material expenses - update",
    "subcontractors-invoices-materials-delete": "Material expenses - delete",
    "services-show": "Services - list",
    "services-create": "Services - create",
    "services-update": "Services - update",
    "services-delete": "Services - delete",
    "measures-show": "Measures - list",
    "measures-create": "Measures - create",
    "measures-update": "Measures - update",
    "measures-delete": "Measures - delete",
    "fuels-types-show": "Fuel types - list",
    "fuels-types-create": "Fuel types - create",
    "fuels-types-update": "Fuel types - update",
    "fuels-types-delete": "Fuel types - delete",
    "subcontractors-types-show": "Subcontractor types - list",
    "subcontractors-types-create": "Subcontractor types - create",
    "subcontractors-types-update": "Subcontractor types - update",
    "subcontractors-types-delete": "Subcontractor types - delete",
    "tanks-show": "Tanks - list",
    "tanks-create": "Tanks - create",
    "tanks-update": "Tanks - update",
    "tanks-delete": "Tanks - delete",
    "gps-tanks-show": "GPS tanks - list",
    "users-show": "Users - list",
    "users-create": "Users - create",
    "users-update": "Users - update",
    "users-delete": "Users - delete",
    "roles-show": "Roles - list",
    "roles-create": "Roles - create",
    "roles-update": "Roles - update",
    "roles-delete": "Roles - delete",
    "statistics-show": "Statistics",
    "assignments-show": "Assignments - list",
    "assignments-create": "Assignments - create",
    "assignments-update": "Assignments - update",
    "assignments-delete": "Assignments - delete",
    "service-show": "Service - list",
    "service-create": "Service - create",
    "service-update": "Service - update",
    "service-delete": "Service - delete",
    "service-locations-show": "Service locations - list",
    "service-locations-create": "Service locations - create",
    "service-locations-update": "Service locations - update",
    "service-locations-delete": "Service locations - delete",
    "service-visits-show": "Service visits - list",
    "service-visits-create": "Service visits - create",
    "service-visits-update": "Service visits - update",
    "service-visits-delete": "Service visits - delete",
    "mechanic": "Mechanic",
    "transport-manager": "Transport manager",
    "mechanics-show": "Mechanics - list",
    "mechanic-hours-show": "Mechanic hours - list",
    "mechanic-hours-create": "Mechanic hours - create",
    "mechanic-hours-update": "Mechanic hours - update",
    "mechanic-hours-delete": "Mechanic hours - delete",
    "ai-invoices-show": "AI invoices - list",
    "ai-invoices-create": "AI invoices - create",
    "ai-invoices-update": "AI invoices - update",
    "ai-invoices-delete": "AI invoices - delete",
    "ai-invoice-rows-show": "AI invoice rows - list",
    "ai-invoice-rows-create": "AI invoice rows - create",
    "ai-invoice-rows-update": "AI invoice rows - update",
    "ai-invoice-rows-delete": "AI invoice rows - delete",
    "machine-service-signals-show": "Machine service signals - list",
    "machine-service-signals-delete": "Machine service signals - delete",
    "ai-companies-show": "AI companies - list",
    "ai-companies-create": "AI companies - create",
    "ai-companies-update": "AI companies - update",
    "ai-invoice-accounting-value-types-show":
      "Accounting value types - list",
    "ai-invoice-accounting-value-types-create":
      "Accounting value types - create",
    "ai-invoice-accounting-value-types-update":
      "Accounting value types - update",
    "ai-invoice-accounting-value-types-delete":
      "Accounting value types - delete",
    "ai-invoice-accounting-values-show": "Accounting values - list",
    "ai-invoice-accounting-values-create": "Accounting values - create",
    "ai-invoice-accounting-values-update": "Accounting values - update",
    "ai-invoice-accounting-values-delete": "Accounting values - delete"
  }
};
